import React from 'react'
import { number, string, array } from 'prop-types'

import ProTipItem from './ProTipItem'

function PublishingScoreTooltip({
  descriptionLength,
  tagsLength,
  imagesLength,
  embedsLength,
  files,
  type,
}) {
  const fileFormatsTipByType = type === 'cg' ? (
    'Buyers most often need these file formats: FBX, OBJ, MAX, STL, ZTL.'
  ) : (
    'Most popular 3D print formats among buyers: STL, OBJ, AMF, 3MF, FBX.'
  )

  function countUniqueFileFormats() {
    const uniqueFileFormats = []
    const fileExtensionsForCg = [
      'fbx', 'obj', 'ztl', 'stl', 'max', 'uasset', 'ma', 'mb', 'unitypackage', '3ds', 'blend', 'c4d', '3dm', 'mtl', 'ige', 'iges', 'igs',
      'dae', 'stp', 'rfa', 'lw', 'lwo', 'lws', 'mat', 'hrc', 'xsi', 'skp', 'X', 'pdf', 'pp2', 'pz3', 'b3d', 'wrl', 'wrz', 'dxf', 'lxl', 'lxo',
    ]
    const fileExtensionsForPrint = ['stl', 'obj', 'amf', '3mf', 'fbx', 'wrl', '3ds', 'ige', 'iges', 'igs', 'stp']

    files.forEach((file) => {
      const extension = file.name.split('.').pop().toLowerCase()
      const availableExtensionsArray = type === 'cg' ? fileExtensionsForCg : fileExtensionsForPrint

      if (!uniqueFileFormats.includes(extension) && availableExtensionsArray.includes(extension)) {
        uniqueFileFormats.push(extension)
      }

      file.contents.forEach((contentFileName) => {
        const contentExtension = contentFileName.split('.').pop().toLowerCase()

        if (!uniqueFileFormats.includes(contentExtension) && availableExtensionsArray.includes(contentExtension)) {
          uniqueFileFormats.push(contentExtension)
        }
      })
    })

    return uniqueFileFormats.length
  }

  return (
    <div className="publishing-score-tooltip">
      <div className="heading-18 cgt-legacy-color-white-100">Pro tips for Publishing score</div>
      <ProTipItem
        heading="Add at least 3 file formats."
        tip={fileFormatsTipByType}
        isChecked={countUniqueFileFormats() >= 3}
      />
      <ProTipItem
        heading="Add at least 5 preview images."
        tip="20+ preview images sell 5-10 times better than those with a single image."
        isChecked={imagesLength >= 5}
      />
      <ProTipItem
        heading="Embed your model previews from Marmoset, Youtube or Vimeo."
        tip="Embedded previews can triple the sales of your product."
        isChecked={embedsLength > 0}
      />
      <ProTipItem
        heading="Add a detailed description. 30 words minimum."
        tip="Products with a description of 50-100 words are sold up to 3 times more often."
        isChecked={descriptionLength >= 29}
      />
      <ProTipItem
        heading="Add at least 10 tags. See tag suggestions to get some ideas."
        tip="Best selling products have 15-20 tags that are relevant to their type and category."
        isChecked={tagsLength >= 10}
      />
    </div>
  )
}

PublishingScoreTooltip.propTypes = {
  descriptionLength: number.isRequired,
  tagsLength: number.isRequired,
  imagesLength: number.isRequired,
  embedsLength: number.isRequired,
  files: array.isRequired,
  type: string.isRequired,
}

export default PublishingScoreTooltip
